import CargoShipperSuccess from "./cargo-shipper.container";

export default CargoShipperSuccess;
